import {Assets} from './assets';
import {IThemeImages} from './architecture/sections/theme-images.interface';
import {IFontFamily} from './architecture/sections/font-family.interface';
import {IGeneralColors} from './architecture/sections/general-colors.interface';
import { IFontSize } from './architecture/sections/font-size.interface';
import {ThemeIconsFactory} from './architecture/theme-icons-factory';
import {IThemeIcons} from './architecture/sections/theme-icons.interface';
import { createBaseUIComponents } from './base-ui-components-theme';
import { IBaseUIComponents, OrbitTheme } from './architecture/orbit-theme.interface';
import { JackpotType } from '../../common/const/jackpot_map_ids';
import { ThemeName } from './architecture/theme-names';
import { mediaQueries } from "../services/media-query/media-queries";

function createDefaultImages(): IThemeImages {

    return {
        spriteSheet: Assets.images.SpriteSheetPC1920_png,
        shadowBackground: Assets.images.shaddow_bg_png,
        onlyRealMoneyGameWarning: Assets.images.only_real_money_game_warning_png,
        horizontalLineGlowPC: Assets.images.horizontal_line_glow_png,
        horizontalLineGlowMobile: Assets.images.horizontal_line_glow_mobile_png,
        verticalLineGlow: Assets.images.vertical_line_glow_png,
        gameIconPlaceHolder: Assets.images.placeholder_game_icon_png,
        gameIconPlaceHolderSq: Assets.images.placeholder_game_icon_sq_png,
        emptyImage: Assets.images.empty_image_gif,
        emptyImageSq: Assets.images.empty_image_sq_gif,
        gameDefaultBackground: Assets.images.game_default_background_png,
        gameDefaultIcon: Assets.games.game_icon_placeholder_png,
        closeModalDialog: Assets.images.close_modal_dialog_png,
        closeModalDialogHover: Assets.images.close_modal_dialog_png,
        texture: Assets.images.texture_png,
        checkMark: Assets.images.check_png,
        intermediatePageGameInfoButton: Assets.images.infoBTN_png,
        brokenLinkIcon: Assets.images.broken_link_icon_png,
        logoDecoration: Assets.images.side_menu_header_decoration_png,
        headerArenaIconDropShadow: Assets.images.arena_shaddow_png,
        gamesListTitle: {
            dailyJackpot: Assets.images.jackpot_widget_title_crown_png,
            exclusive: Assets.images.exclusives_list_icon_png
        },
        miniOrbit: {
            headerIcons: {
                search: Assets.images.mini_orbit.cip.header_icons.search_png,
                moreMenu: Assets.images.mini_orbit.cip.header_icons.moreMenu_png,
                gift: Assets.images.mini_orbit.cip.header_icons.gift_png
            },
            arenasHeaderButtons: {
                selected: Assets.images.mini_orbit.cip.arenas_header_buttons.selected_png,
                unselected: Assets.images.mini_orbit.cip.arenas_header_buttons.unselected_png
            },
            spinner: {
                blackBackground: Assets.images.blackSquare_png
            }
        },
        singleGame: {
            defaultBackgroundImage: Assets.images.games_icons_background.BGGameBlack_png,
            cardAndTablesBackgroundImage: Assets.images.games_icons_background.BGcardandtable_png,
            defaultSquareBackgroundImage: Assets.images.games_icons_background.BGGameBlackSquare_png,
            cardAndTablesSquareBackgroundImage: Assets.images.games_icons_background.BGcardandtable_png,
        },
        liveArena: {
            activeIndicatorBg: Assets.images.live_arena.active_indicator_bg_png,
            casinoLiveLogoMobile: Assets.images.casino_live_logo_mobile_png,
            casinoLiveLogoPC: Assets.images.casino_live_logo_png,
            dealerIcon: Assets.images.live_arena.dealer_icon_png,
            seatIcon: Assets.images.live_arena.seat_icon_png,
            fullSeatIcon: Assets.images.live_arena.seat_icon_dark_png,
        },
        responsibleGambling: {
            beGambleAwareLogo: Assets.images.responsible_gambling.begambleaeare_logo_png,
            gameCareLogo: Assets.images.responsible_gambling.gamecare_logo_png,
            safeZoneIcon: Assets.images.responsible_gambling.safeZoneIcon_svg,
        },
        dailyDeal: {
            pc: Assets.images.daily_deal_icon_pc_png,
            mobile: Assets.images.daily_deal_icon_mobile_png
        },
        jackpotWidget: {
            byType: {
                [JackpotType.Daily]: {
                    background: Assets.images.jackpot_widget.daily.background_png,
                    logo: Assets.images.jackpot_widget.daily.logo_png
                },
                [JackpotType.HighNoon]: {
                    background: Assets.images.jackpot_widget.high_noon.background_png,
                    logo: Assets.images.jackpot_widget.high_noon.logo_png
                },
                [JackpotType.Twilight]: {
                    background: Assets.images.jackpot_widget.twilight.background_png,
                    logo: Assets.images.jackpot_widget.twilight.logo_png
                },
                [JackpotType.Party]: {
                    background: Assets.images.jackpot_widget.live_party.background_png,
                    logo: Assets.images.jackpot_widget.live_party.logo_png,
                }
            },
            generic: {
                crown: Assets.images.jackpot_widget.crown_png,
                infoBoxPc: Assets.images.jackpot_widget.info_dialog.pc_png,
                infoBoxMobile: Assets.images.jackpot_widget.info_dialog.mobile_png,
                infoBoxMobileLandscape: Assets.images.jackpot_widget.info_dialog.mobile_landscape_png
            },
        },
        party: {
            in_game_widget_background: Assets.images.jackpot_widget.party.in_game_widget_background_png,
            toaster_icon: Assets.images.jackpot_widget.party.toaster_icon_png,
            winning: Assets.images.jackpot_widget.party.winning_png
        },
        liveParty: {
            in_game_widget_background: Assets.images.jackpot_widget.live_party.in_game_widget_background_png,
        },
        germanyPanicButton: Assets.images.germany_panic_icon_png,
        homepageTopBannerPlaceholder: Assets.images.top_banner_placeholder_gif
    };
}

function createDefaultFontSizes(): IFontSize {
    return {
        medium: "15px",
        mediumSecondary: "14px"
    };
}

export interface MakeThemeOptions {
    themeName: ThemeName;
    fonts: IFontFamily;
    fontSizes?: Partial<IFontSize>;
    generalColors: IGeneralColors;
    themeSpecificIcons: Partial<IThemeIcons> | null;
    baseUIComponents?(generalColors: IGeneralColors, defaults: IBaseUIComponents): IBaseUIComponents;
}

export function makeTheme(options: MakeThemeOptions): OrbitTheme {
    let defaultBaseUIComponents = createBaseUIComponents(options.generalColors);
    let baseUIComponents = options.baseUIComponents ? options.baseUIComponents(options.generalColors, defaultBaseUIComponents) : defaultBaseUIComponents;
    return {
        themeName: options.themeName,
        font: {
            family: options.fonts,
            size: {...createDefaultFontSizes(), ...options.fontSizes}
        },
        colors: options.generalColors,
        baseUIComponents,
        images: createDefaultImages(),
        icons: new ThemeIconsFactory(options.themeSpecificIcons),
        layout: {
            border: {
                radius: '5px'
            },
            wrapper: {
                padding: {
                    mobile: '1rem',
                    pc: '4rem'
                },
                stickyMenuHeight: '82px',
            },
            navbar:{
                width: '23rem',
            }
        },
        components: {
            generalTitle: {
                colors: {
                    background: 'linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))'
                }

            },
            gamesListTitle: {
                colors: {
                    text: {
                        regular: options.generalColors.brandSecondary,
                        dailyJackpot: options.generalColors.brandPrimary,
                        redTigerJackpot: "#ff014f"
                    }
                }
            },
            partyJackpotInGameWidget: {
                colors: {
                    amount: "#fce403",
                    timer: "#ffffff"
                }
            },
            partyJackpotWinCelebrationPopup: {
                colors: {
                    title: "#fce403",
                    amount: options.generalColors.bodyText
                }
            },
            intermediatePage: {
                colors: {
                    gameInfoButton: "#ffffff"
                }
            },
            gamePreviewInfo: {
                colors: {
                    infoText: options.generalColors.bodyText
                }
            },
            modalDialog: {
                colors: {
                    background: options.generalColors.bodyBackground
                },
                closeButtonSize: "18px"
            },
            lobbyGameInfoPreview: {
                colors: {
                    gameInfoTableBackground: options.generalColors.bodyBackgroundLight
                }
            },
            newLiveCasino: {
                colors: {
                    filterButtonBackground: "#323232",
                    filterButtonLabel: "#888",
                    miniOrbit: {
                        filterButtonBackgroundNormal:`transparent linear-gradient(180deg, #4A4A4A 0%, #0C0C0C 100%) 0% 0% no-repeat padding-box`,
                        filterButtonBackgroundActive: `transparent linear-gradient(180deg, #0185DD 0%, #004270 100%) 0% 0% no-repeat padding-box`,
                        filterBorder: "#000000"
                    },
                    navbarBoxShadow: '#0c0c0c',
                    gridItem: {
                        closedMessageBackground: '#141414',
                        drawRedItemBackground: '#ff2f2f',
                        drawRedItemFirstChildBackground: '#DC1515',
                        drawGreenItemFirstChildBackground: '#3B8A08',
                        infobarBackground: '#191919',
                        wrapperBorder: '#5f5f5f'
                    }
                }
            },
            header: {
                colors: {
                    indicatorBadge: {
                        text: "#FFFFFF",
                        backgroundInGridLayout: "#FF014F",
                        backgroundInListLayout: "#171717"
                    }
                }
            },
            jackpotWidget: {
                font: {
                    clock: "'Digital7'"
                }
            }
        },
        mediaQuery: mediaQueries
    };
}


